function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.194 5.25h-.916V4.083C11.278 1.832 9.358 0 7 0 4.641 0 2.722 1.832 2.722 4.083V5.25h-.916a.299.299 0 0 0-.306.292v7.291c0 .644.548 1.167 1.222 1.167h8.556c.674 0 1.222-.523 1.222-1.167V5.542a.299.299 0 0 0-.306-.292zm-4.28 6.093a.284.284 0 0 1-.075.227.312.312 0 0 1-.228.097H6.39a.312.312 0 0 1-.228-.097.284.284 0 0 1-.076-.227l.193-1.655a1.138 1.138 0 0 1-.5-.938c0-.643.548-1.167 1.222-1.167.674 0 1.222.524 1.222 1.167 0 .377-.187.72-.5.938l.193 1.655zm1.53-6.093H4.556V4.083C4.556 2.797 5.652 1.75 7 1.75c1.348 0 2.444 1.047 2.444 2.333V5.25z"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.67495aaf.svg";
export { ForwardRef as ReactComponent };